import TumengDisplay from './src/index.vue'

TumengDisplay.install = function(Vue) {
  Vue.component(TumengDisplay.name, TumengDisplay)
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(TumengDisplay)
}

export default TumengDisplay
